<div class="roles">
  @for (role of roles; track role.tagId) {
    <app-tag [tag]="role" (clickTag)="handleRoleClick(role)"/>
  }
</div>
